import Vue from 'vue'
import store from './store'
import router from './router'

// VEE
import VeeValidate from 'vee-validate';
import veeDutch from 'vee-validate/dist/locale/nl';
Vue.use(VeeValidate, {
    dictionary: {
        locale: 'en',
        en: { messages: veeDutch.messages},
    }
});

//FLATPICKR
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/airbnb.css';
Vue.use(VueFlatPickr);

import VueScrollTo from "vue-scrollto";
Vue.use(VueScrollTo)

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)


require('./mixins')

Vue.config.devtools = true
Vue.component('intake', require('./components/Intake.vue').default)
Vue.component('intake-finish', require('./components/IntakeFinish.vue').default)
new Vue({
    el: '#intake',
    store,
    router
});
